import { SET_SELECTION, SET_SELECTION_LOADING } from "@/redux/types";

export const setSelection = (selection) => ({
    payload: { selection },
    type: SET_SELECTION,
});

export const setSelectionLoading = (key, isLoading) => ({
    payload: {
        isLoading,
        key,
    },
    type: SET_SELECTION_LOADING,
});
